import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../Store'
import { setCookieState, CookieStates } from '../../Store/StateHandlers/program-slice'
import { colors, fonts } from '../../Styles';
import { NewModal, MainContentPaddingTypes, NewButton } from '..';
export interface CookieModal_Props {
}

//Is state Self handling... could be ref'ed..
const CookieModal = ({ }: CookieModal_Props) => {
  const {t} = useTranslation();
  const dispatch = useAppDispatch()
  
  const CookieState = useAppSelector(({Program}) => Program.CookieLevel)
  const [CookieModal, setCookieModal] = useState(CookieState>=CookieStates.FirstInit?true:false)

  const changeCookieState = (level:number) => {
    if (level !== CookieState) dispatch(setCookieState({level}))
    setCookieModal(false)
  }

  const seperator = <div style={{width: "100%", height: "2px", backgroundColor: colors.blueDarkSecondary}}/>

  return (
    <NewModal
      header={t("cookie.header", {defaultValue: "cookies"})}
      modalState={CookieModal}
      predefinedButtons={{
        onClose: () => changeCookieState(CookieState)
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary,
        mainContentScroll: true
      }}
      mainContent={ <>
        <div style={{whiteSpace: 'wrap', maxWidth: "400px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "20px"}}>
          {seperator}
          <p style={{...fonts.paragraph, ...fonts.fontSize7, color: colors.greyLightTertiary, textAlign: "center"}}>{`${t("cookie.context1")}`}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize7, color: colors.greyLightTertiary, textAlign: "center"}}>{`• ${t("cookie.purpose1")}`}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize7, color: colors.greyLightTertiary, textAlign: "center"}}>{`• ${t("cookie.purpose2")}`}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize7, color: colors.greyLightTertiary, textAlign: "center"}}>{`${t("cookie.context2")}`}</p>
          {seperator}
          <div style={{display: "flex", gap: "10px"}}>
            <NewButton
              content={t("cookie.accept")} 
              onClick={() => changeCookieState(CookieStates.Necessary)}
              overrides={{
                baseStyles: {width: "fit-content"}
              }}
            />
            <NewButton
              content={t("cookie.acceptAll")}
              onClick={() => changeCookieState(CookieStates.All)}
              overrides={{
                baseStyles: {width: "fit-content"}
              }}
            />
          </div>
        </div>
      </> }
    />
  )
}

export default CookieModal
